const common = {
  // Existing keys
  Pricing: '요금제',
  Calculator: '계산기',
  Promotion: '프로모션',
  Schedule: '스케줄',
  'Get Started': '시작하기',
  'Manage Spacecraft': '위성 관리',
  'Contact Profile': '교신프로필 관리',
  'Schedule a Contact': '스케줄 예약하기',
  'Manage Contacts': '스케줄 관리',
  Support: '지원',
  FAQ: '자주 묻는 질문',
  'Contact Us': '문의하기',
  'SpaceTime Tools': '우주시간 도구',
  'Commanding':'명령 송신',

  // Added keys
  Home: '홈',
  Dashboard: '대시보드',
  Admin: '관리자',
  'Manage User': '사용자 관리',
  'Manage Ground Station': '지상국 관리',
  'Manage S3': 'S3 관리',
  'Manage Schedule': '전체 스케줄 관리',
  'Manage Payment': '결제 관리',
  'Manage Mail': '메일 관리',
  'Manage Inquiry': '문의 관리',
  'Manage Promotion': '프로모션 관리'
};

const spacetimeTools = {
  pageTitle: 'SpaceTime Tools',
  description: '시간, 좌표, 위성 TLE 데이터 변환을 위한 간단하고 정확한 도구',
  tabs: {
    timeConversion: 'Time Conversion',
    coordinateTransformation: 'Coordinate Transformation',
    tleDataConverter: 'TLE Data Converter'
  }
};

export { spacetimeTools };
export default common;